/*
 * @Author: wuqinfa
 * @Date: 2024-04-22 15:23:19
 * @LastEditors: wuqinfa
 * @Description: 
 */
import * as API from '@/services/survey';

export default {
  namespace: 'survey',
  state: {
    schoolList: [],
    schoolQueryList: [],
    surveyTemplateQueryList: [],
    surveyTemplateDetail: {},
  },
  effects: {
    *surveyPage({ payload }: any, { call, put }: any): any {
      const res = yield call(API.surveyPage, payload);

      const {
        records = [],
        current = 1,
        size = 10,
        total = 0,
      } = res.data || {};

      // ProTable 的 request 属性，需要返回特定数据结构的 Promise 对象
      return {
        data: records,
        total,
        success: true,
        page: current,
        pageSize: size,
      };
    },

    *surveySave({ payload }: any, { call, put }: any): any {
      return yield call(API.surveySave, payload);
    },

    *surveyDetail({ payload }: any, { call, put }: any): any {
      return yield call(API.surveyDetail, payload);
    },

    *surveySubmit({ payload }: any, { call, put }: any): any {
      return yield call(API.surveySubmit, payload);
    },

    *surveyExport({ payload }: any, { call, put }: any): any {
      return yield call(API.surveyExport, payload);
    },

    *surveyUpdateStatus({ payload }: any, { call, put }: any): any {
      return yield call(API.surveyUpdateStatus, payload);
    },

    *getSchoolList({ payload }: any, { call, put }: any): any {
      const res = yield call(API.getSchoolList, payload);
      yield put({
        type: '_setState',
        payload: {
          schoolList: res.data
        },
      });
      return res;
    },

    *surveyTemplateQuery({ payload }: any, { call, put }: any): any {
      const res = yield call(API.surveyTemplateQuery, payload);
      yield put({
        type: '_setState',
        payload: {
          surveyTemplateQueryList: res.data
        },
      });
      return res;
    },
    
    *getScopeSchool({ payload }: any, { call, put }: any): any {
      const res = yield call(API.getScopeSchool, payload);
      yield put({
        type: '_setState',
        payload: {
          schoolQueryList: res.data
        },
      });
      return res;
    },

    *surveyTemplateDetail({ payload }: any, { call, put }: any): any {
      const res = yield call(API.surveyTemplateDetail, payload);

      yield put({
        type: '_setState',
        payload: {
          surveyTemplateDetail: res.data
        },
      });
      return res;
    },
  },
  reducers: {
    _setState(state: any, { payload }: any) {
      return {
        ...state,
        ...payload,
      };
    },
  },
}